export const load = () => ({
	title: 'Heat Blocking Window Solutions',
	h1: 'Beat the Heat and Maximize Cooling with Window Inserts',
	description:
		'Insulate your windows from heat to keep your home cool on hot days, reduce A/C use, and save on energy bills.',
	showTitle: true,
});
